import { styled as o } from "styled-components";
import { Icon as e } from "../../../../components/Icon/index.js";
import { Caption as r } from "../../../../styles/typography/index.js";
import { Colors as t } from "../../../../styles/colors/index.js";
const n = o(e)`
  font-size: 24px;
`, l = o.span`
  display: flex;
  align-items: center;

  ${r}
  color: rgb(${t.Gray});
`;
export {
  n as DeletedIcon,
  l as DeletedMessageWrapper
};
